<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '45vw' }"
  [breakpoints]="{ '960px': '70vw', '640px': '95vw' }" [draggable]="false" (onHide)="closeDialog()" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center gap-3 w-full">
      <div class="position-relative d-inline-block">
        <div class="lobby-header-avatar"
          [class.avatar-clickable]="lobby()?.hostPhotoUrl"
          [style.cursor]="lobby()?.hostPhotoUrl ? 'pointer' : 'default'"
          (click)="lobby()?.hostPhotoUrl && openImageInNewTab($event)">
          @if (lobby()?.hostPhotoUrl) {
            <img [src]="lobby()?.hostPhotoUrl" alt="Host" class="lobby-avatar-img" />
          }
          @if (!lobby()?.hostPhotoUrl) {
            <span class="lobby-avatar-initials">
              {{ lobby()?.hostInitials || 'N/A' }}
            </span>
          }
        </div>


      </div>

      <div class="flex-1">
        <div class="d-flex align-items-center gap-2 mb-1">
          <h3 class="m-0 text-black">{{ lobby()?.theme || 'N/A' }}</h3>
          <p-tag [value]="lobby()?.status" [styleClass]="getStatusSeverity(lobby()?.status || '')"
            styleClass="p-1 text-xs font-semibold" />
          </div>
          <small class="text-500 text-black">Lobby ID: <code>{{ lobby()?._id }}</code></small>
        </div>
      </div>
    </ng-template>

    @if (lobby(); as lobbyData) {
      <div class="lobby-details">

        <!-- Deleted banner -->
        @if (lobbyData.deletedAt) {
          <div class="deleted-banner">
            <i class="pi pi-exclamation-triangle"></i>
            <span>This lobby has been deleted
              on {{ lobbyData.deletedAt | date: 'dd MMM yyyy, HH:mm' }}
            </span>
          </div>
        }

        <!-- Status Overview -->
        <div class="section">
          <h4 class="section-title">
            <i class="pi pi-chart-line mr-2"></i>
            Lobby Overview
          </h4>
          <div class="status-grid">
            <div class="status-card active">
              <i class="pi pi-heart status-icon"></i>
              <div class="status-content">
                <span class="status-label">Interest</span>
                <span class="status-value-text">{{ lobbyData.interestsCount ? (lobbyData.currentInterestIdx ?? 0) + 1 : 0 }} / {{ lobbyData.interestsCount ?? 0 }}</span>
              </div>
            </div>

            <div class="status-card active">
              <i class="pi pi-users status-icon"></i>
              <div class="status-content">
                <span class="status-label">Participants</span>
                <span class="status-value-text">{{ lobbyData.entries }} / {{ lobbyData.capacity }}</span>
              </div>
            </div>

            <div class="status-card active">
              <i class="pi pi-dollar status-icon"></i>
              <div class="status-content">
                <span class="status-label">Entry Fee</span>
                <span class="status-value-text">{{ lobbyData.price === 0 ? 'Free' : ('$' + lobbyData.price + '.00')
                }}</span>
              </div>
            </div>

            <div class="status-card active">
              <i class="pi pi-wallet status-icon"></i>
              <div class="status-content">
                <span class="status-label">Revenue</span>
                <span class="status-value-text">${{ lobbyData.revenue }}.00</span>
              </div>
            </div>

            <div class="status-card active">
              <i class="pi pi-tag status-icon"></i>
              <div class="status-content">
                <span class="status-label">Type</span>
                <span class="status-value-text text-capitalize">{{ lobbyData.type || 'Featured' }}</span>
              </div>
            </div>
          </div>
        </div>

        <p-divider></p-divider>

        <!-- Details Section -->
        <div class="section">
          <h4 class="section-title">
            <i class="pi pi-info-circle mr-2"></i>
            Information
          </h4>
          <div class="grid">
            <div class="col-12 md:col-6 item-row">
              <label class="detail-label">Host Name</label>
              <p class="detail-value">{{ lobbyData.host | titlecase }}</p>
            </div>
            @if (lobbyData.hostEmail) {
              <div class="col-12 md:col-6 item-row">
                <label class="detail-label">Host Email</label>
                <p class="detail-value"><code>{{ lobbyData.hostEmail }}</code></p>
              </div>
            }
            <div class="col-12 md:col-6 item-row">
              <label class="detail-label">Start Time</label>
              <p class="detail-value">
                <i class="pi pi-calendar mr-2 text-500"></i>
                {{ lobbyData.startTime | date: 'yyyy-MM-dd HH:mm' }}
              </p>
            </div>
            <div class="col-12 md:col-6 item-row">
              <label class="detail-label">Created At</label>
              <p class="detail-value">
                <i class="pi pi-clock mr-2 text-500"></i>
                {{ lobbyData.createdAt ? (lobbyData.createdAt | date: 'yyyy-MM-dd HH:mm') : 'N/A' }}
              </p>
            </div>
            <div class="col-12 md:col-6 item-row">
              <label class="detail-label">Current Round</label>
              <p class="detail-value">Round {{ lobbyData.currentRound }} / {{ lobbyData.totalRounds }}</p>
            </div>
            <div class="col-12 md:col-6 item-row">
              <label class="detail-label">Participant Gender</label>
              <p class="detail-value text-capitalize">{{ lobbyData.participantsGender || 'N/A' }}</p>
            </div>
            <div class="col-12 md:col-6 item-row">
              <label class="detail-label">Interest Gender</label>
              <p class="detail-value text-capitalize">{{ lobbyData.interestsGender || 'N/A' }}</p>
            </div>
            @if (lobbyData.isRecurring !== undefined) {
              <div class="col-12 md:col-6 item-row">
                <label class="detail-label">Recurring Lobby</label>
                <p class="detail-value">{{ lobbyData.isRecurring ? 'Yes' : 'No' }}</p>
              </div>
            }
            @if (lobbyData.deletedAt) {
              <div class="col-12 md:col-6 item-row">
                <label class="detail-label" style="color: #ef4444;">Deleted On</label>
                <p class="detail-value" style="color: #ef4444;">
                  <i class="pi pi-trash mr-2"></i>
                  {{ lobbyData.deletedAt | date: 'dd MMM yyyy, HH:mm' }}
                </p>
              </div>
            }
            @if (lobbyData.description) {
              <div class="col-12 item-row mt-2">
                <label class="detail-label">Description</label>
                <p class="detail-value description-text">{{ lobbyData.description }}</p>
              </div>
            }
          </div>
        </div>

        <!-- Unified Attendees Section -->
        <div class="section attendees-section mt-4">
          <div class="d-flex flex-wrap gap-2 mb-3">
            <button class="btn-tab" [class.active]="selectedTab() === 'all'" (click)="setTab('all')">
              All <span class="tab-count">{{ attendeesCount.all }}</span>
            </button>
            <button class="btn-tab" [class.active]="selectedTab() === 'participants'" (click)="setTab('participants')">
              <i class="pi pi-users me-1"></i> Participants <span class="tab-count">{{ attendeesCount.participants }}</span>
            </button>
            <button class="btn-tab" [class.active]="selectedTab() === 'interests'" (click)="setTab('interests')">
              <i class="pi pi-heart me-1"></i> Interest <span class="tab-count">{{ attendeesCount.interests }}</span>
            </button>
            <button class="btn-tab" [class.active]="selectedTab() === 'spectators'" (click)="setTab('spectators')">
              <i class="pi pi-eye me-1"></i> Spectators <span class="tab-count">{{ attendeesCount.spectators }}</span>
            </button>
          </div>

          <div class="attendees-list d-flex flex-column" style="max-height: 350px; overflow-y: auto;">
            @if (filteredAttendees().length === 0) {
              <div class="text-muted py-3 text-center">
                No records found.
              </div>
            }

            @for (p of filteredAttendees(); track p) {
              <div class="attendee-item d-flex align-items-center justify-content-between py-2 border-bottom">
                <div class="d-flex align-items-center gap-2">
                  <div class="attendee-avatar d-flex align-items-center justify-content-center rounded-circle font-semibold" style="background-color: #dbeafe; color: #1e40af; width: 42px; height: 42px; font-size: 16px; overflow: hidden; flex-shrink: 0;">
                    @if (p.userId && p.userId.ProfilePhotos && p.userId.ProfilePhotos.length > 0) {
                      <img
                        [src]="p.userId.ProfilePhotos[0].signedUrl || p.userId.ProfilePhotos[0].url"
                        alt="Avatar" class="rounded-circle" style="object-fit: cover; width: 100%; height: 100%;" />
                    }
                    @if (!p.userId || !p.userId.ProfilePhotos || p.userId.ProfilePhotos.length === 0) {
                      <span>
                        {{ (p.userId?.FirstName || p.role)[0] | uppercase }}{{ (p.userId?.LastName || '')[0] | uppercase }}
                      </span>
                    }
                  </div>
                  <div>
                    <div class="fw-bold text-black" style="font-size: 0.95rem;">
                      @if (p.userId && p.userId.FirstName) {
                        <span>
                          {{ p.userId.FirstName | titlecase }} {{ p.userId.LastName | titlecase }}
                        </span>
                      } @else {
                        User ID: <code>{{ p.userId }}</code>
                      }
                    </div>
                    @if (p.userId && p.userId.email) {
                      <div class="text-muted mt-0" style="font-size: 0.85rem;">
                        {{ p.userId.email }}
                      </div>
                    }
                  </div>
                </div>
                <div class="d-flex align-items-center gap-3">
                  <span class="role-badge fw-medium" [ngClass]="'role-' + p.role.toLowerCase()">
                    {{ p.role }}
                  </span>
                  @if (p.joinedAt) {
                    <span class="text-muted" style="font-size: 0.85rem; min-width: 80px; text-align: right;">
                      {{ p.joinedAt | date: 'MM-dd-yyyy' }}
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </p-dialog>

  <!-- Host photo preview overlay -->
  @if (hostPreviewUrl()) {
    <div class="host-photo-preview-overlay" (click)="closeHostPreview()">
      <button class="host-preview-close-btn" (click)="closeHostPreview()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
      <img [src]="hostPreviewUrl()!" alt="Host photo" class="host-preview-img" (click)="$event.stopPropagation()" />
    </div>
  }